<template>
  <div>
    <claim-tabs :activeClaimTab="claimTab"></claim-tabs>
  </div>
</template>

<script>
import ClaimTabs from "@/components/claims/tabs.vue";
export default {
  name: "Claims",
  props: ["claimTab"],
  components: {
    ClaimTabs,
  },
};
</script>
